import { c as _c } from "react/compiler-runtime";
import Footer from "@/lib/components/common/Footer";
import Header from "@/lib/components/common/Header";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BaseLayout(t0) {
  const $ = _c(11);
  const {
    children,
    headerMode: t1,
    showFooter: t2,
    transparentHeader: t3
  } = t0;
  const headerMode = t1 === undefined ? "full" : t1;
  const showFooter = t2 === undefined ? true : t2;
  const transparentHeader = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== headerMode || $[1] !== transparentHeader) {
    t4 = /*#__PURE__*/_jsx(Header, {
      mode: headerMode,
      transparent: transparentHeader
    });
    $[0] = headerMode;
    $[1] = transparentHeader;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children) {
    t5 = /*#__PURE__*/_jsx("main", {
      className: "flex-1",
      children: children
    });
    $[3] = children;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== showFooter) {
    t6 = showFooter && /*#__PURE__*/_jsx(Footer, {});
    $[5] = showFooter;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "flex min-h-screen flex-col",
      children: [t4, t5, t6]
    });
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}